module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
  return _vm._c('button', {
    class: _vm.setClass(),
    attrs: {
      "id": "gv-button-ricerca-catastale",
      "title": "Ricerche Catastali"
    },
    on: {
      "click": _vm.onClick
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-660c325a!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/buttons/S3RicercaCatastale.vue
// module id = 880
// module chunks = 39